import React, {useEffect, useState} from "react";
import Chatheader from "../chatheader/chatheader";
import { useStateValue } from '../../../../stateprovider';
import "./payment.css";
import { useNavigate } from "react-router-dom";

const ChatPayment = () => {
    const navigate = useNavigate();
    const paymentSelect = [
        {minute: 30, amount: 1000, },
        {minute: 60, amount: 2000, },
    ]
    const [{  }, dispatch] = useStateValue();
    const [select, setSelect] = useState(0);
    const [amount, setAmount] = useState(paymentSelect[0].amount);

    useEffect(()=>{
        dispatch({
            type: "APP_NAV_STATE",
            appnav: true
        });
    }, []);

    const MakePayment = () => {
        navigate("/awaiting-medical-pro")
    }

    return <div className="app_complaint">
        <Chatheader />
        <div className="app_complaint_container">
            <div className="app_complaint_text">
                <h1>Subscribe to a plan</h1>
                <p>Get your personal doctor in your pocket and ready to go any time.</p>
            </div>
            <div className="app_payment_select_container">
               {paymentSelect.map((payment, index) => {
                return <div className={index === select ? "app_payment_select" : "app_payment_select_disabled app_payment_select"} key={index}
                    onClick={()=> {
                        setSelect(index);
                        setAmount(payment.amount);
                    }}
                >
                <div className="app_payment_select_top">
                    <p>{payment.minute} minutes Chat</p>
                    <p>&#8358;&nbsp;{payment.amount}</p>
                </div>
                <p>Live chat with a doctor</p>
            </div>
               }) }
            </div>
            <button className="app_buttonactive  app_paymentbutton" onClick={MakePayment}>Subscribe</button>
        </div>

    </div>
}
export default ChatPayment;